import parse from 'html-react-parser';
import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { breakTranslationNewlines } from '../../../../utils';
import { StyledBenefitCard } from './BenefitCard.styled';

export type BenefitCardProps = {
  title: string;
  description: ReactNode;
  icon: ReactNode;
};

const BenefitCard: FC<BenefitCardProps> = ({ title, description, icon }) => {
  const { t } = useTranslation();

  return (
    <StyledBenefitCard className="cedolauto-card">
      <div className="cedolauto-card__title">
        {parse(breakTranslationNewlines(t(title)))}
      </div>

      <div className="cedolauto-card__icon">{icon}</div>

      <div className="cedolauto-card__description">
        {typeof description === 'string'
          ? parse(breakTranslationNewlines(t(description)))
          : description}
      </div>
    </StyledBenefitCard>
  );
};

export default BenefitCard;
